module.exports = __webpack_public_path__ + "static/img/8半分利.eb8017b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/8半分利.jpg
// module id = vRtk
// module chunks = 0